import { render, staticRenderFns } from "./AppAdminSynergyForm.vue?vue&type=template&id=06f1939e&scoped=true&"
import script from "./AppAdminSynergyForm.vue?vue&type=script&lang=ts&"
export * from "./AppAdminSynergyForm.vue?vue&type=script&lang=ts&"
import style0 from "./AppAdminSynergyForm.vue?vue&type=style&index=0&id=06f1939e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1939e",
  null
  
)

export default component.exports